module.exports = __webpack_public_path__ + "static/img/DINProMedium.7119c27f.svg";